import { useEffect, useState } from 'react';

const getElementHeight = elementId => {
  const element = document.getElementById(elementId);

  if (element) {
    const style = window.getComputedStyle(element);
    if (style.display !== 'none') {
      return element.offsetHeight;
    }
  }

  return 0;
};

const useElementHeight = ({ elementId, waitForElement = true }) => {
  const [elementHeight, setElementHeight] = useState(0);

  useEffect(() => {
    let observer;
    let resizeObserver;
    let timeoutId;

    const updateHeight = () => {
      const height = getElementHeight(elementId);
      setElementHeight(height);
    };

    const observeElement = () => {
      const targetElement = document.getElementById(elementId);
      if (targetElement) {
        updateHeight();

        resizeObserver = new ResizeObserver(() => {
          updateHeight();
        });
        resizeObserver.observe(targetElement);
      }
    };

    if (waitForElement) {
      observer = new MutationObserver(() => observeElement());
      observer.observe(document.body, { childList: true, subtree: true });

      timeoutId = setInterval(() => {
        const element = document.getElementById(elementId);
        if (element) {
          updateHeight();
          if (resizeObserver) resizeObserver.observe(element);
          clearInterval(timeoutId);
        }
      }, 100);
    } else {
      observeElement();
    }

    window.addEventListener('resize', updateHeight);

    return () => {
      if (observer) observer.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      if (timeoutId) clearInterval(timeoutId);
      window.removeEventListener('resize', updateHeight);
    };
  }, [elementId, waitForElement]);

  return elementHeight;
};

export default useElementHeight;
